import UserSignupGrid from "./components/UserGrid";
import CompanySignup from "./components/CompanyGrid";
import { useAppSelector } from "../../../hooks/useRedux";
export default function SignupPage() {
  const signupType = useAppSelector((state) => state.setting.signupGrids);

  return signupType === "user" ? <UserSignupGrid /> : <CompanySignup />;
}
